import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ToastNotification.css';
import { CancelWithBorderIcon } from '@shared/Icons/CancelWithBorderIcon';
import { SuccessWithBorderIcon } from '@shared/Icons/SuccessWithBorderIcon';
import { WarningIcon } from '@shared/Icons/WarningIcon';

const ToastNotifications = () => {
    return (
        <ToastContainer
            position="top-center"
            autoClose={2000}
            hideProgressBar
            closeButton={false}
            newestOnTop
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
        />
    );
};

export const notifySuccessCustom = (
    message: string,
    opt?: { autoClose: number }
) => {
    toast.dismiss();
    toast.success(message, {
        icon: (
            <SuccessWithBorderIcon
                width={45}
                height={45}
                stroke={'#ffffff'}
                className="iconSvg"
            />
        ),
        className: 'custom-toast-container-order custom-toast-order',
        position: 'top-left',
        autoClose: opt?.autoClose ?? 2500,
        hideProgressBar: true,
        closeButton: false,
    });
};

export const notifyWarningCustom = (
    message: string,
    opt?: { autoClose: number }
) => {
    toast.dismiss();
    toast.warning(message, {
        icon: (
            <WarningIcon
                width={45}
                height={45}
                fill={'#ffffff'}
                stroke={'#ffffff'}
            />
        ),
        className: 'custom-toast-container-order custom-toast-order-warning',
        position: 'top-left',
        autoClose: opt?.autoClose ?? 2500,
        hideProgressBar: true,
        closeButton: false,
    });
};

export const notifyErrorCustom = (
    message: string,
    opt?: { autoClose: number }
) => {
    toast.dismiss();
    toast.error(message, {
        icon: (
            <CancelWithBorderIcon
                width={45}
                height={45}
                fill={'#E30613'}
                stroke={'#ffffff'}
            />
        ),
        className: 'custom-toast-container-order custom-toast-order-error',
        position: 'top-left',
        autoClose: opt?.autoClose ?? 2500,
        hideProgressBar: true,
        closeButton: false,
    });
};

export default ToastNotifications;
